export const PUBLIC_WEB_CONTENT_TEST_ID = {
    ARTICLE_CATEGORY_LINK: 'article-category-link',
    NOT_FOUND_PRIMARY_BUTTON: 'not-found-primary-button',
    NOT_FOUND_SECONDARY_BUTTON: 'not-found-secondary-button',
};
